// extracted by mini-css-extract-plugin
module.exports = {"policy":"PrivacyPolicy-module--policy--37riG","header":"PrivacyPolicy-module--header--1wyul","content":"PrivacyPolicy-module--content--2dGDt"};